// extracted by mini-css-extract-plugin
module.exports = {"optionsButton":"options-button_optionsButton__3rv3I","optionsButton__label":"options-button_optionsButton__label__Q5eQX"};